const CurrencyUtil = (function () {
	return {
		format: function (number, currency_info, without_html) {
			var decimals = currency_info.frac_digits;
			var dec_point = currency_info.decimal_point;
			var thousands_sep = currency_info.thousands_sep;
			decimals = Math.abs(decimals);

			if (isNaN(decimals)) {
				decimals = 2;
			}
			if (dec_point === undefined) {
				dec_point = ',';
			}
			if (thousands_sep === undefined) {
				thousands_sep = '.';
			}

			number = (+number || 0).toFixed(decimals);

			var integer_part = parseInt(number) + '';
			var integer_part_length = integer_part.length;
			var padding_length = 0;

			if (integer_part_length > 3) {
				padding_length = integer_part_length % 3;
			}

			var result = '';

			if (padding_length) {
				result += integer_part.substr(0, padding_length) + thousands_sep;
			}

			result += integer_part.substr(padding_length).replace(/(\d{3})(?=\d)/g, '$1' + thousands_sep);

			if (decimals && (number - integer_part)) {
				result += dec_point + Math.abs(number - integer_part).toFixed(decimals).slice(2);
			}

			var sign;

			if (without_html) {
				sign = currency_info.sign;
			} else {
				sign = currency_info.sign_html;
			}

			if (!currency_info.sign_position) {
				return sign + currency_info.sign_delim + result;
			} else {
				return result + currency_info.sign_delim + sign;
			}
		},

		parse: function (format_number, currency_info, without_html) {
			var decimals = currency_info.frac_digits;
			decimals = Math.abs(decimals);

			if (isNaN(decimals)) {
				decimals = 2;
			}

			var dec_point = currency_info.decimal_point;

			if (dec_point === undefined) {
				dec_point = ',';
			}

			var sign;

			if (without_html) {
				sign = currency_info.sign;
			} else {
				sign = currency_info.sign_html;
			}

			if (!currency_info.sign_position) {
				format_number = format_number.substr(-(currency_info.sign_delim.length + sign.length));
			} else {
				format_number = format_number.substr(0, format_number.length - (currency_info.sign_delim.length + sign.length));
			}

			var decimal_part = '0';
			var integer_part = format_number;

			if (format_number.substr(-decimals - 1, 1) === dec_point) {
				decimal_part = format_number.substr(-decimals);
				integer_part = format_number.substr(0, format_number.length - decimals - 1);
			}

			var integer_sign = 1;

			if (integer_part.charAt(0) === '-') {
				integer_sign = -1;
				integer_part = integer_part.substr(1);
			}

			var integer_part_length = integer_part.length;
			var padding_length = 0;

			if (integer_part_length > 4) {
				padding_length = integer_part_length % 4;
			}

			var result = integer_part.substr(0, padding_length);
			result += integer_part.substr(padding_length === 0 ? 0 : padding_length + 1).replace(/.(?=\d\d\d)/, '');

			return (parseFloat(result) + parseFloat('0.' + decimal_part)) * integer_sign;
		}
	};
})();

export default CurrencyUtil;

